import React, { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import ConfigData from "../../master/components/ConfigData";
import { Checkbox, Button, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, } from "@material-ui/core";
import AircraFamilyList from "../component/AircraftFamilyList";
import { EmptyCollection, FilterComponent, Pagination, ImportMenu, DeletePopUp, PageLoader, STableLoader, RevisionHistory } from "../../../shared_elements";
import { globalDeleteService, globalExportService, globalFileUploadService, globalGetService, globalPutService } from "../../../../globalServices";
import { checkApiStatus, checkPermission } from "../../../utils_v2";
import AddEditAircraftFamily from "../component/AddEditAircraftFamily";
import { trackActivity } from "../../../../utils/mixpanel";
import AddIcon from '@material-ui/icons/Add';
import { aircraftFamilyFilters } from "..";
import { usePageTitleOffset } from '../../../elements/CollapsibleSideNav';

const AircraftFamilyObj = {
    name: null,
    ac_type: null,
    manufacturer: null,
    remarks: null
}

const AircraftListHeader = ({ handleSelectAll, isSelectAllChecked, sortInfo, createSortHandler }) => {
    return (
        <TableHead>
            <TableRow>
                <TableCell style={{ position: 'sticky', left: 0, backgroundColor: '#B5BEDB', zIndex: 10, }}> <div style={{ width:"130px" }}>{checkPermission('config_data', 'aircraft_family', 'D') && <Checkbox checked={isSelectAllChecked} onChange={handleSelectAll} color="primary" size="small" />}Action(s)</div></TableCell>
                <TableCell >
                    <div style={{ width:"150px" }}>
                    <TableSortLabel
                        active={sortInfo.sort === 'name' ? true : false}
                        direction={sortInfo.sort === 'name' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('name')}
                    >
                        Name
                    </TableSortLabel>
                    </div>
                </TableCell>
                <TableCell >
                    <div style={{ width:"150px" }}>
                    <TableSortLabel
                        active={sortInfo.sort === 'manufacturer' ? true : false}
                        direction={sortInfo.sort === 'manufacturer' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('manufacturer')}
                    >
                        Manufacturer
                    </TableSortLabel>
                    </div>
                </TableCell>
                <TableCell > Linked A/C Types </TableCell>
                <TableCell >
                    <div style={{ width:"150px" }}>
                    <TableSortLabel
                        active={sortInfo.sort === 'created_by' ? true : false}
                        direction={sortInfo.sort === 'created_by' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('created_by')}
                    >
                        Created By
                    </TableSortLabel>
                    </div>
                </TableCell>
                <TableCell >
                    <div style={{ width:"150px" }}>
                    <TableSortLabel
                        active={sortInfo.sort === 'updated_by' ? true : false}
                        direction={sortInfo.sort === 'updated_by' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('updated_by')}
                    >
                        Last Updated By
                    </TableSortLabel>
                    </div>
                </TableCell>
                <TableCell >
                    <div style={{ width:"200px" }}>
                        <TableSortLabel
                            active={sortInfo.sort === 'remarks' ? true : false}
                            direction={sortInfo.sort === 'remarks' ? sortInfo.sort_by : 'asc'}
                            onClick={() => createSortHandler('remarks')}
                        >
                            Remarks
                        </TableSortLabel>
                    </div>
                </TableCell>
            </TableRow>
        </TableHead >
    )
}
const AircraftFamily = () => {
    const navTitleOffset = usePageTitleOffset('configDataNavCollapsed');
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState({});
    const [pageSelections, setPageSelections] = useState({});
    const [currentPage, setCurrentPage] = useState({});
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [bulkDelete, setBulkDelete] = useState({ modal: false, data: null })
    const [bulkRevert, setBulkRevert] = useState({ modal: false, data: null })
    const [deleteAircraftFamily, setDeleteAircraftFamily] = useState({ modal: false, data: null });
    const [revertAircraftFamily, setRevertAircraftFamily] = useState({ modal: false, data: null });
    const [addEditAircraftFamily, setAddEditAircraftFamily] = useState({ modal: false, data: null, type: '' });
    const [aircraftFamilyInfo, setAircraftFamilyInfo] = useState({ list: [], pagination:{} });
    const [manufacturersFilter, setManufacturersFilter] = useState([]);
    const [filterAircraftTypes, setFilterAircraftTypes] = useState([]);

    useEffect(() => {
        getAirCraftFamily({per_page:50},"skeletonLoader")
        trackActivity('Console Management', { page_title: 'Config Data : Aircraft Family', event_type: 'Page Visited' })
        getManufacturers()
        getAircraftTypes()
    }, [])

    const getAirCraftFamily = (query={}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`config-data/aircraft-family/`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setAircraftFamilyInfo(response?.data?.data)
                    if(query){
                        delete query.page
                        delete query.per_page
                        delete query.sort
                        delete query.sort_by
                        setFilter(query)
                    }
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }

    const toggleBulkOps = (item, checked, currentPage) => {
        setPageSelections(prevSelections => {
            const updatedSelections = { ...prevSelections };
            if (checked) {
                updatedSelections[currentPage] = updatedSelections[currentPage] || [];
                updatedSelections[currentPage].push(item?.id);
            } else {
                updatedSelections[currentPage] = updatedSelections[currentPage]?.filter(id => id !== item?.id);
            }
            return updatedSelections;
        });
    };

    const onDelete = () => {
        setLoading(true)
        const ids = !deleteAircraftFamily.data ? Object.values(pageSelections).flat().filter(id => {
            const item = aircraftFamilyInfo.list.find(item => item.id === id);
            return item && !item.deleted_at;
        }) : deleteAircraftFamily.data.id

        globalDeleteService(`config-data/aircraft-family/bulk-delete/`, { ids })
            .then(response => {
                if (checkApiStatus(response)) {
                    setDeleteAircraftFamily({ modal: false, data: null });
                    getAirCraftFamily({...filter, page: aircraftFamilyInfo?.pagination?.page, per_page: aircraftFamilyInfo?.pagination?.per_page}, 'pageLoader');
                    setCurrentPage({});
                    setLoading(false)
                    setPageSelections({});
                    setBulkDelete({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Aircraft Family',
                        event_type: `Item Deleted`,
                        event_desc: 'Aircraft Family Deleted Successfully',
                        success_msg: response?.data?.message,
                        deleted_id: ids
                    });
                } else {
                    setDeleteAircraftFamily({ modal: false, data: null });
                    setLoading(false)
                    setPageSelections({});
                    setBulkDelete({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Aircraft Family',
                        event_type: `Item Deleted`,
                        event_desc: 'Aircraft Family Deletion Failed',
                        error_msg: response?.data?.message,
                        item_id: ids
                    });
                }
            });
    };

    const onRevert = () => {
        setLoading(true)
        const ids = !revertAircraftFamily.data ? Object.values(pageSelections).flat().filter(id => {
            const item = aircraftFamilyInfo.list.find(item => item.id === id);
            return item && item.deleted_at;
        }) : revertAircraftFamily.data;

        globalPutService(`config-data/aircraft-family/restore/`, { ids })
            .then(response => {
                if (checkApiStatus(response)) {
                    setRevertAircraftFamily({ modal: false, data: null });
                    getAirCraftFamily({...filter, page: aircraftFamilyInfo?.pagination?.page, per_page: aircraftFamilyInfo?.pagination?.per_page}, 'pageLoader');
                    setCurrentPage({});
                    setLoading(false)
                    setPageSelections({});
                    setBulkRevert({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Aircraft Family',
                        event_type: `Item Reverted`,
                        event_desc: 'Aircraft Family Reverted Successfully',
                        success_msg: response?.data?.message,
                        reverted_id: ids
                    });
                } else {
                    setRevertAircraftFamily({ modal: false, data: null });
                    setLoading(false)
                    setPageSelections({});
                    setBulkRevert({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Aircraft Family',
                        event_type: `Item Reverted`,
                        event_desc: 'Aircraft Family Reversion Failed',
                        error_msg: response?.data?.message,
                        item_id: ids
                    });
                }
            });
    };

    const handleSelectAll = (event, currentPage) => {
        if (event?.target.checked) {
            const allIds = aircraftFamilyInfo?.list.map(item => item.id);
            setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: allIds }));
        } else {
            setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: [] }));
        }
    };

    const getFilteredSelectionCounts = () => {
        let deleteCount = 0;
        let revertCount = 0;

        if (pageSelections[currentPage]?.length) {
            pageSelections[currentPage].forEach(id => {
                const selectedItem = aircraftFamilyInfo?.list?.find(item => item?.id === id);

                if (selectedItem) {
                    if (selectedItem?.deleted_at) {
                        revertCount++;
                    } else {
                        deleteCount++;
                    }
                }
            });
        }
        return { deleteCount, revertCount };
    };

    const { deleteCount, revertCount } = getFilteredSelectionCounts();

    const createSortHandler = (key) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort_by: 'asc' }
        }
        setSortInfo(sortQuery)
        getAirCraftFamily({ ...filter, ...sortQuery, page: 1, per_page: aircraftFamilyInfo?.pagination?.per_page || 20 }, 'pageLoader');
    }

    const isSelectAllChecked = aircraftFamilyInfo?.list?.length > 0 && pageSelections[currentPage]?.length === aircraftFamilyInfo?.list?.length;

    const getConfirmColor = () => {
        if (revertAircraftFamily?.modal || bulkRevert?.modal) return "primary";
        if (deleteAircraftFamily?.modal || bulkDelete?.modal) return "secondary";
        return "";
    };

    const getConfirmText = () => {
        if (revertAircraftFamily?.modal || bulkRevert?.modal) return "Revert";
        if (deleteAircraftFamily?.modal || bulkDelete?.modal) return "DELETE";
        return "";
    };

    const getModal = () => {
        if (revertAircraftFamily?.modal) return revertAircraftFamily.modal;
        if (deleteAircraftFamily?.modal) return deleteAircraftFamily.modal;
        if (bulkDelete?.modal) return bulkDelete.modal;
        if (bulkRevert?.modal) return bulkRevert.modal;
        return null;
    };

    const getTitle = () => {
        if (revertAircraftFamily?.modal) return "Revert Aircraft Family";
        if (deleteAircraftFamily?.modal) return "Delete Aircraft Family";
        if (bulkDelete?.modal) return `Delete Aircraft Family (${deleteCount})`;
        if (bulkRevert?.modal) return `Revert Aircraft Family (${revertCount})`;
        return "";
    };

    const getContent = () => {
        if (revertAircraftFamily?.modal || bulkRevert?.modal)
            return "Are you sure, you want to Revert?";
        if (deleteAircraftFamily?.modal || bulkDelete?.modal)
            return "Are you sure, you want to Delete?";
        return "";
    };

    const toggleModalFn = () => {
        if (revertAircraftFamily?.modal) {
            setRevertAircraftFamily({ modal: false, data: null });
        } else if (deleteAircraftFamily?.modal) {
            setDeleteAircraftFamily({ modal: false, data: null });
        } else if (bulkDelete?.modal) {
            setBulkDelete({ modal: false, data: null });
        } else {
            setBulkRevert({ modal: false, data: null });
        } 
    };


    const getDeleteRecordFn = () => {
        if (revertAircraftFamily?.modal || bulkRevert?.modal) return onRevert;
        if (deleteAircraftFamily?.modal || bulkDelete?.modal) return onDelete;
        return null;
    };

    const getManufacturers = () => {
        globalGetService(`config-data/manufacturers/?lite=true`)
            .then(response => {
                if (checkApiStatus(response)) {
                    let manufacturersFilter = [];
                    const data = response?.data?.data;
                    data && data.map((item) => {
                        manufacturersFilter.push({ id: item?.id, name: item?.name })
                    });
                    setManufacturersFilter(manufacturersFilter);
                }
            })
    }
    const getAircraftTypes = () => {
        globalGetService(`config-data/aircraft-type/?lite=true`)
            .then(response => {
                if (checkApiStatus(response)) {
                    let aircraftTypeInfo = [];
                    const data = response?.data?.data;
                    data && data.map((item) => {
                        aircraftTypeInfo.push({ id: item?.id, name: item?.name })
                    });
                    setFilterAircraftTypes(aircraftTypeInfo);
                }
            })
    }

    let filterOption = aircraftFamilyFilters
    filterOption={
        ...filterOption,
         manufacturer:{
            ...filterOption.manufacturer,
            options:manufacturersFilter
        },
         aircraft_type:{
            ...filterOption.aircraft_type,
            options:filterAircraftTypes
        },
    }

    return (
        <section className="asset-tech-specs" style={{ margin: '25px 0 0 75px' }}>
            <Paper elevation={0} className="tech-specs-card console-paper" style={{ height: `${window.innerHeight - 89}px` }}>
                <ConfigData />
                <div className="tech-specs-content" style={{ paddingTop: '0px' }}>
                {skeletonLoader ? <STableLoader count={6} size={9} /> :
                    <div style={{ padding: '10px' }}>
                        <Paper elevation={0} className="console-paper" style={{ padding: '5px 10px', marginBottom: "2px" }}>
                            <Grid container spacing={1} alignItems="center">
                                <Grid item md={6}>
                                            <FilterComponent
                                                filter={filter}
                                                filterMenu={filterOption}
                                                getResponseBack={(applyFilter) => { getAirCraftFamily({ ...applyFilter, page: 1, per_page: aircraftFamilyInfo?.pagination?.per_page || 10 }, 'pageLoader') }}
                                            />
                                 </Grid>
                                <Grid item md={6}>
                                    <ul className='list-inline flex-centered' style={{ float: 'right' }}>
                                        {revertCount > 0 && (
                                            <li className='list-inline-item'>
                                                <Button onClick={() => { setBulkRevert({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Aircraft Family', item_type: 'Bulk Revert', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Revert Modal from Aircraft Family` }) }} color="primary" size='small' variant="outlined">
                                                    Revert ({revertCount})
                                                </Button>
                                            </li>
                                        )}
                                        {deleteCount > 0 && (
                                            <li className='list-inline-item'>
                                                <Button onClick={() => { setBulkDelete({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Aircraft Family', item_type: 'Bulk Delete', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Delete Modal from Aircraft Family` }) }} color="secondary" size='small' variant="contained">
                                                    Delete ({deleteCount})
                                                </Button>
                                            </li>
                                        )}
                                        {checkPermission('config_data', 'aircraft_family', 'C') &&  <li className='list-inline-item'>
                                            <Button onClick={() => setAddEditAircraftFamily({ modal: true, data: AircraftFamilyObj, type: 'add' })} color="primary" size='small' variant="contained"><AddIcon style={{ fontSize: '1.15rem' }} />ADD</Button>
                                        </li>}
                                        <li className='list-inline-item' style={{ cursor: 'pointer' }}>
                                            <RevisionHistory isExp={false} buttonType={true} url={`audit/config-data/cdaircraftfamily/`} queryParams={{ action: '0,1,2' }} />
                                        </li>
                                    </ul>
                                </Grid>
                            </Grid>
                        </Paper>
                        <Paper square>
                         <div style={{ height:`${(window.innerHeight - (aircraftFamilyInfo?.list?.length ? 200 : 150)) - navTitleOffset}px`, overflow: 'auto' }}>
                            <Table className="mui-table-format" stickyHeader>
                                <AircraftListHeader isSelectAllChecked={isSelectAllChecked} handleSelectAll={(e) => handleSelectAll(e, currentPage)} createSortHandler={createSortHandler} sortInfo={sortInfo} />
                                    <TableBody>
                                        {aircraftFamilyInfo?.list?.length > 0 && aircraftFamilyInfo?.list?.map((item, index) =>
                                            <AircraFamilyList
                                                item={item}
                                                index={index}
                                                onDelete={setDeleteAircraftFamily}
                                                onRevert={setRevertAircraftFamily}
                                                onEditFn={() => setAddEditAircraftFamily({ modal: true, data: item, type: 'edit' })}
                                                onViewFn={() => setAddEditAircraftFamily({ modal: true, data: item, type: 'view' })}
                                                toggleBulkOps={(item, checked) => toggleBulkOps(item, checked, currentPage)}
                                                bulkIds={pageSelections[currentPage] || []}
                                            />
                                        )}
                                    </TableBody>
                            </Table>
                               {!aircraftFamilyInfo?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                         </div>
                        </Paper>
                        <Paper square>
                            <Pagination
                                pagination={aircraftFamilyInfo?.pagination}
                                onChangePage={(event, newPage) => { getAirCraftFamily({ ...filter, page: newPage + 1, per_page: aircraftFamilyInfo.pagination?.per_page, sort_by: sortInfo?.sort_by, sort: sortInfo?.sort }, 'pageLoader'); setCurrentPage(newPage + 1) }}
                                onChangeRowsPerPage={(event) => getAirCraftFamily({ ...filter, page: 1, per_page: event.target.value, sort_by: sortInfo?.sort_by, sort: sortInfo?.sort }, 'pageLoader')}
                            />
                        </Paper>
                    </div>}
                </div>
                {addEditAircraftFamily?.modal ?
                    <AddEditAircraftFamily
                        addEditAircraftFamily={addEditAircraftFamily}
                        aircraftFamilyInfo={aircraftFamilyInfo}
                        toggleModalFn={() => setAddEditAircraftFamily({ modal: false, aircraftFamily: [] })}
                        getResponseBack={() => getAirCraftFamily({...filter, page: aircraftFamilyInfo?.pagination?.page, per_page: aircraftFamilyInfo?.pagination?.per_page}, 'pageLoader')}
                        modeType={addEditAircraftFamily?.type}
                    /> : null
                }
                <DeletePopUp
                    confirmColor={getConfirmColor()}
                    confirmText={getConfirmText()}
                    modal={getModal()}
                    title={getTitle()}
                    content={getContent()}
                    toggleModalFn={toggleModalFn}
                    deleteRecordFn={getDeleteRecordFn()}
                />
            </Paper>
            {isLoading ? <PageLoader /> : null}
        </section >
    )
}
export default AircraftFamily;